import React from 'react';
import { CheckCircleIcon, ShieldCheckIcon } from 'lucide-react';
export function BackingSection() {
  const guidelines = ['Sin azúcar ni sal añadida', 'Progresión de texturas', 'Ingredientes reales y locales', 'Sin ultraprocesados'];
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-blue-light via-baby-lavender to-baby-blue" data-id="element-246">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-247">
        <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 md:p-10 rounded-baby-lg shadow-baby-glow border-2 border-baby-blue animate-fade-in-up" data-id="element-248">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-249">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-baby-gradient-blue rounded-full flex items-center justify-center shadow-baby-soft animate-soft-pulse" data-id="element-250">
              <ShieldCheckIcon className="w-7 h-7 sm:w-8 sm:h-8 text-white" data-id="element-251" />
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900" data-id="element-252">
              Respaldo Real
            </h2>
          </div>

          <div className="bg-gradient-to-br from-baby-blue-light to-baby-lavender p-5 sm:p-6 md:p-8 rounded-baby border-2 border-baby-blue-light mb-6" data-id="element-253">
            <p className="text-base sm:text-lg md:text-xl text-gray-800 text-center mb-6 font-medium" data-id="element-254">
              Este ebook respeta las recomendaciones de pediatras y organismos
              de salud:
            </p>

            <div className="grid sm:grid-cols-2 gap-3 sm:gap-4 stagger-children" data-id="element-255">
              {guidelines.map((guideline, index) => <div key={index} className="flex items-center gap-3 bg-white/80 backdrop-blur-baby p-3 sm:p-4 rounded-baby shadow-baby-soft" data-id="element-256">
                  <CheckCircleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-baby-blue flex-shrink-0" data-id="element-257" />
                  <span className="text-sm sm:text-base font-semibold text-gray-800" data-id="element-258">
                    {guideline}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="text-center" data-id="element-259">
            <p className="text-sm sm:text-base text-gray-600 italic" data-id="element-260">
              Y aunque no es un manual médico, puedes estar tranquila de que
              está hecho con respeto y cuidado.
            </p>
          </div>
        </div>
      </div>
    </section>;
}